document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tab");
    const panes = document.querySelectorAll(".tab-pane");

    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            tabs.forEach(t => t.classList.remove("active"));
            panes.forEach(p => p.classList.remove("active"));

            tab.classList.add("active");
            const target = tab.getAttribute("data-tab");
            document.getElementById(target).classList.add("active");
        });
    });

    // Activate the first tab by default
    if (tabs.length > 0) {
        tabs[0].classList.add("active");
        panes[0].classList.add("active");
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(".accordion-header");

    headers.forEach(header => {
        header.addEventListener("click", function () {
            const targetId = header.getAttribute("data-target");
            const content = document.getElementById(targetId);

            if (header.classList.contains("active")) {
                header.classList.remove("active");
                content.style.display = "none";
            } else {
                headers.forEach(h => h.classList.remove("active"));
                document.querySelectorAll(".accordion-content").forEach(c => c.style.display = "none");

                header.classList.add("active");
                content.style.display = "block";
            }
        });
    });
});
